module.exports = __webpack_public_path__ + "static/media/Inclined-Kids7.044b24a8.gif";